import { EMemberChoicesLabels } from '../api/models/memberchoice/memberchoice.types';
import { TReflistQuestion } from '../api/repositories/reflists/reflists.types';

export const getAnswersByLabel = (
  questions: TReflistQuestion[],
  label: string
) =>
  questions
    .filter((value: TReflistQuestion) => {
      return value.label === EMemberChoicesLabels[label];
    })
    .reduce(key => {
      return key;
    });
